module.exports = __webpack_public_path__ + "img/partner36.38c090fa.png";